import { UserAPI } from 'api/user';
import { LS_TEMPLATE_ID_KEY } from 'constant/constant';
import { ApiKey, logger, TokenType } from 'services';
import { authService } from 'services/auth-service';
import { logout } from 'utils/logout';
const SCOPES = [
    'offline_access',
    'openid',
    'profile',
    'email'
];
const authState = (_authState, error)=>({
        isAuthenticated: ApiKey.exists() || authService.getAuthState(),
        error
    });
const logAndReturnAuthState = (state, error)=>{
    var _result_error;
    const result = authState(state, error);
    // Strip DOM/fiber refs from the Okta error before handing to Datadog's logger.
    // The Okta signin widget attaches DOM nodes (HTMLAnchorElement, SVGLinearGradientElement)
    // to its error objects. Datadog's logger calls JSON.stringify(context) synchronously,
    // which throws "Converting circular structure to JSON" via __reactFiber$ → stateNode.
    logger.debug('transformed auth state', {
        result: {
            isAuthenticated: result.isAuthenticated,
            error: result.error instanceof Error ? result.error.message : String((_result_error = result.error) !== null && _result_error !== void 0 ? _result_error : '')
        }
    });
    return result;
};
export const OKTA_REDIRECT_URI = window.location.origin;
export const CONFIG = (issuer, clientId, redirect_uri = OKTA_REDIRECT_URI)=>({
        issuer,
        clientId,
        redirectUri: `${redirect_uri}/implicit/callback`,
        scopes: SCOPES,
        pkce: true,
        tokenManager: {
            autoRenew: false,
            autoRemove: false
        },
        postLogoutRedirectUri: `${redirect_uri}/login`,
        transformAuthState: async (_, state)=>{
            const params = new URLSearchParams(window.location.search);
            if (params.get('templateId')) {
                localStorage.setItem(LS_TEMPLATE_ID_KEY, params.get('templateId'));
            }
            logAndReturnAuthState(state, state === null || state === void 0 ? void 0 : state.error);
            const authenticated = ApiKey.exists();
            if (!authenticated && state.accessToken != null) {
                try {
                    await ApiKey.create(state.accessToken.accessToken, TokenType.Okta, clientId);
                } catch (error) {
                    logger.error('api key creation failed', {
                        error
                    });
                    return logAndReturnAuthState(state, error);
                }
                try {
                    await UserAPI.clearOktaSession();
                } catch (error) {
                    logger.error('could not clear okta session via API, logging out', {
                        error
                    });
                    logout();
                }
            }
            return logAndReturnAuthState(state);
        }
    });
